import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import ReadingParty from '@/components/readingParty/ReadingParty'
import ReadingDetail from '@/components/readingDetail/ReadingDetail'
import Introduce from '@/components/introduce/Introduce'
import BigHome from '@/components/bigHome/BigHome'
import Culture from '@/components/culture/Culture'
import News from '@/components/news/News'
import NewsDetail from '@/components/newsDetail/NewsDetail'
import Responsibility from '@/components/responsibility/Responsibility'
import Sidebar from '@/components/sidebar/Sidebar'
import GotoContent from '@/components/gotoContent/GotoContent'
import SpecialColumn from '@/components/specialColumn/SpecialColumn'
import Anniversary from '@/components/anniversary/anniversary'
import UniversityHall from '@/components/universityHall/university-hall'
import NewsTemplate from '@/components/newsTemplate/index'
import ResearchSystem from '@/components/researchSystem/ResearchSystem'
import TrusteeCouncil from '@/components/trusteeCouncil/TrusteeCouncil'
import MentorTeam from '@/components/mentorTeam/MentorTeam'
import NotFound from '@/components/404/index'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '走进亚商',
      component: Home
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/readingParty',
      name: 'ReadingParty',
      component: ReadingParty
    },
    {
      path: '/readingDetail/:id',
      name: 'ReadingDetail',
      component: ReadingDetail
    },
    {
      path: '/bigHome',
      name: '亚商大家庭',
      component: BigHome
    },
    {
      path: '/culture',
      name: '亚商文化',
      component: Culture
    },
    {
      path: '/news',
      name: '亚商动态',
      component: News
    },
    {
      path: '/responsibility',
      name: '社会责任',
      component: Responsibility
    },
    {
      path: '/newsDetail/:id',
      name: '亚商动态',
      component: NewsDetail
    },
    {
      path: '/gotoContent/:name',
      name: '走进亚商',
      component: GotoContent,
    },
    {
      path: '/specialColumn',
      name: 'SpecialColumn',
      component: SpecialColumn
    },
    {
      path: '/anniversary',
      name: 'Anniversary',
      component: Anniversary
    },
    {
      path: '/news-template',
      name: '亚商动态',
      component: NewsTemplate
    },
    {
      path: '/news-list',
      name: '亚商动态',
      component: NewsTemplate
    },
    {
      path: '/university-hall',
      name: '亚洲商务大学堂',
      component: UniversityHall
    },
    {
      path: '/research-system',
      name: '亚洲商务大学堂',
      component: ResearchSystem
    },
    {
      path: '/trustee-council',
      name: '亚洲商务大学堂',
      component: TrusteeCouncil
    },
    {
      path: '/mentor-team',
      name: '亚洲商务大学堂',
      component: MentorTeam
    }
  ]
});
//全局守卫
router.beforeEach((to, form, next) =>{
  window.scroll(0, 0);
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js